module.exports = __webpack_public_path__ + "img/bg.b550c2f9.png";